import React, { Component } from "react";
import PropTypes from "prop-types";
import RichTextEditor from "react-rte";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";

class CustomerNoteForm extends Component {
  constructor(props) {
    super(props);
    this.state = { canSubmit: false, value: RichTextEditor.createEmptyValue() };
  }

  componentDidMount = () => {
    const { note } = this.props;
    if (note.note) {
      this.setState({
        value: RichTextEditor.createValueFromString(note.note, "html")
      });
    }
  };

  onChange = (value) => {
    this.setState({ value });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    model.note = this.state.value.toString("html");
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.note._id;
    model.note = this.state.value.toString("html");
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { note, adding } = this.props;

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={12} xs={12}>
            <Input
              required
              name="title"
              label="Title"
              value={note.title}
              validations={{ maxLength: 250 }}
              validationErrors={{
                maxLength: "You can not type in more than 250 characters"
              }}
            />
          </Col>
          <Col md={12} xs={12}>
            <RichTextEditor
              className={this.props.auth.isNightMode ? "dark" : ""}
              value={this.state.value}
              onChange={this.onChange}
            />
          </Col>
          <Col md={12} xs={12} className="footer">
            <button
              type="button"
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn btn-success"
              type="submit"
              disabled={!this.state.canSubmit || this.props.saving}
              value={this.props.saving ? "Saving... " : "Save"}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

CustomerNoteForm.propTypes = {
  adding: PropTypes.bool,
  onAdd: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  note: PropTypes.object,
  auth: PropTypes.object
};

export default CustomerNoteForm;
